// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ueJO","question":"styles_question__Cxnx0","inputVisibleButton":"styles_inputVisibleButton__1hSIc","note":"styles_note__1iY4_"};